<!-- 核销城市运营积分接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "wxAppId": "wx4965abff0ba79af7",
                "carCode": "粤B88888",
                "parkCode": "2KKN6111",
                "pointsValue": 500,
                "usedUsePhone": "13800138000",
                "usedUserOpenId": "oS2eTwwc0DN55MMqcOTVy433S68U",
                "billCode": "2018070513481555662867",
                "payTime": "2018-07-31 11:14:39",
                "payMode": 4,
                "payModeRemark": "通联",
                "payOrigin": 7,
                "payOriginRemark": "智慧停车",
            },
            responseCode: {
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "智慧停车使用第三方运营积分后，主动将使用信息通知第三方",
                urlPattern: this.commonUrls.third+"pointsUse",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "第三方提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'wxAppId', info2: '是', info3: 'String', info4: '微信公众号appId' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '使用积分的车牌' },
                        { info1: 'pointsValue', info2: '是', info3: 'Integer', info4: '积分使用值' },
                        { info1: 'usedUserPhone', info2: '否', info3: 'String', info4: '使用人手机号' },
                        { info1: 'usedUserOpenId', info2: '否', info3: 'String', info4: '使用人微信openId' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '流水号' },
                        { info1: 'payTime', info2: '是', info3: 'String', info4: '支付时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式(请<url>参考附录:/Api/appendixData</url>)' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源(请<url>参考附录:/Api/appendixData</url>)' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                            { info1: 'status', info2: '是', info3: 'int', info4: '状态码: 1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                            { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码, 只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误'},
                            { info1: 'message', info2: '否', info3: 'String', info4: '失败时的原因描述' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/points/pointsUse.vue